/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MissionPopupModel } from './MissionPopupModel';
import {
    MissionPopupModelFromJSON,
    MissionPopupModelFromJSONTyped,
    MissionPopupModelToJSON,
} from './MissionPopupModel';
import type { NewArticlePopupModel } from './NewArticlePopupModel';
import {
    NewArticlePopupModelFromJSON,
    NewArticlePopupModelFromJSONTyped,
    NewArticlePopupModelToJSON,
} from './NewArticlePopupModel';
import type { PopupBannerModel } from './PopupBannerModel';
import {
    PopupBannerModelFromJSON,
    PopupBannerModelFromJSONTyped,
    PopupBannerModelToJSON,
} from './PopupBannerModel';
import type { TermAgreementModel } from './TermAgreementModel';
import {
    TermAgreementModelFromJSON,
    TermAgreementModelFromJSONTyped,
    TermAgreementModelToJSON,
} from './TermAgreementModel';
import type { TopPopupModelRecommendationPopup } from './TopPopupModelRecommendationPopup';
import {
    TopPopupModelRecommendationPopupFromJSON,
    TopPopupModelRecommendationPopupFromJSONTyped,
    TopPopupModelRecommendationPopupToJSON,
} from './TopPopupModelRecommendationPopup';
import type { TopPopupModelWaitFreeChargeCompletePopupInner } from './TopPopupModelWaitFreeChargeCompletePopupInner';
import {
    TopPopupModelWaitFreeChargeCompletePopupInnerFromJSON,
    TopPopupModelWaitFreeChargeCompletePopupInnerFromJSONTyped,
    TopPopupModelWaitFreeChargeCompletePopupInnerToJSON,
} from './TopPopupModelWaitFreeChargeCompletePopupInner';

/**
 * トップページに表示されるポップアップ一覧
 * @export
 * @interface TopPopupModel
 */
export interface TopPopupModel {
    /**
     * 
     * @type {number}
     * @memberof TopPopupModel
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof TopPopupModel
     */
    userName?: string;
    /**
     * トップページに表示されるキャンペーンポップアップバナー(top_popup_banner)
     * @type {Array<PopupBannerModel>}
     * @memberof TopPopupModel
     */
    campaignPopup?: Array<PopupBannerModel>;
    /**
     * トップページに表示される「待つと無料」で閲覧した作品の「待つと無料」チャージが完了したポップアップ(top_waitfree_return_dialog)
     * @type {Array<TopPopupModelWaitFreeChargeCompletePopupInner>}
     * @memberof TopPopupModel
     */
    waitFreeChargeCompletePopup?: Array<TopPopupModelWaitFreeChargeCompletePopupInner>;
    /**
     * トップページに表示されるお気に入り登録時の新しいエピソードポップアップ(top_new_article_popup_dialog)
     * @type {Array<NewArticlePopupModel>}
     * @memberof TopPopupModel
     */
    newArticlePopup?: Array<NewArticlePopupModel>;
    /**
     * 
     * @type {TopPopupModelRecommendationPopup}
     * @memberof TopPopupModel
     */
    recommendationPopup?: TopPopupModelRecommendationPopup;
    /**
     * 
     * @type {TermAgreementModel}
     * @memberof TopPopupModel
     */
    agreementTermPopup?: TermAgreementModel;
    /**
     * 
     * @type {MissionPopupModel}
     * @memberof TopPopupModel
     */
    missionPopup?: MissionPopupModel;
}

/**
 * Check if a given object implements the TopPopupModel interface.
 */
export function instanceOfTopPopupModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TopPopupModelFromJSON(json: any): TopPopupModel {
    return TopPopupModelFromJSONTyped(json, false);
}

export function TopPopupModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopPopupModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'campaignPopup': !exists(json, 'campaignPopup') ? undefined : ((json['campaignPopup'] as Array<any>).map(PopupBannerModelFromJSON)),
        'waitFreeChargeCompletePopup': !exists(json, 'waitFreeChargeCompletePopup') ? undefined : ((json['waitFreeChargeCompletePopup'] as Array<any>).map(TopPopupModelWaitFreeChargeCompletePopupInnerFromJSON)),
        'newArticlePopup': !exists(json, 'newArticlePopup') ? undefined : ((json['newArticlePopup'] as Array<any>).map(NewArticlePopupModelFromJSON)),
        'recommendationPopup': !exists(json, 'recommendationPopup') ? undefined : TopPopupModelRecommendationPopupFromJSON(json['recommendationPopup']),
        'agreementTermPopup': !exists(json, 'agreementTermPopup') ? undefined : TermAgreementModelFromJSON(json['agreementTermPopup']),
        'missionPopup': !exists(json, 'missionPopup') ? undefined : MissionPopupModelFromJSON(json['missionPopup']),
    };
}

export function TopPopupModelToJSON(value?: TopPopupModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'userName': value.userName,
        'campaignPopup': value.campaignPopup === undefined ? undefined : ((value.campaignPopup as Array<any>).map(PopupBannerModelToJSON)),
        'waitFreeChargeCompletePopup': value.waitFreeChargeCompletePopup === undefined ? undefined : ((value.waitFreeChargeCompletePopup as Array<any>).map(TopPopupModelWaitFreeChargeCompletePopupInnerToJSON)),
        'newArticlePopup': value.newArticlePopup === undefined ? undefined : ((value.newArticlePopup as Array<any>).map(NewArticlePopupModelToJSON)),
        'recommendationPopup': TopPopupModelRecommendationPopupToJSON(value.recommendationPopup),
        'agreementTermPopup': TermAgreementModelToJSON(value.agreementTermPopup),
        'missionPopup': MissionPopupModelToJSON(value.missionPopup),
    };
}

